import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { BetHistoryServices } from '../../services/BetHistoryServices';
import * as BullCache from "../../util/BullCache";

function Bethistory(){

  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);
  const [Client, setclient] = useState([]);


  var user = BullCache.getFromCache("user");
  useEffect(() => {
    BetHistoryServices.getAll({ 'adminId': user.adminId }).then(res => {

      if (res.code === 1) {

        if (res.data.masterList.length > 0) {

          setMaster(res.data.masterList);
        }
        if (res.data.brokerList.length > 0) {

          setBroker(res.data.brokerList);
        }


      }

    });

    BetHistoryServices.getusers({ 'adminId': user.adminId }).then(res => {

      if (res.code === 1) {

        if (res.data.userList.length > 0) {
          setclient(res.data.userList);
        }
      }


    });

  }, []);


  return(
      <div className='container-fluid'>
      <Card>
    
    <Card.Body>
      <Row>
               <Col><b style={{fontSize:12}}>TRADE AFTER</b>
               <input type="date" name="bday" />
               </Col>
               <Col><b  style={{fontSize:12}}> TRADE BEFORE</b>
               <input type="date" name="bday" />
               </Col>
               
                 <Col> <b style={{fontSize:12}}>MARKET</b>
                            <Form.Select aria-label="Default select example" size='sm' className='bg-light text-black'style={{fontSize:12}}>
                                <option>MARKET</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                  
                 </Col>
                 <Col className=''>  <b style={{fontSize:12}}>SCRIPT</b>
                            <Form.Select aria-label="Default select example" size='sm' className='bg-light text-black'style={{fontSize:12}}>
                                <option>SCRIPT NAME</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                 </Col>

                 <Col className=''> <b style={{fontSize:12}}>MASTER</b>
                            <Form.Select aria-label="Default select example" size='sm' className='bg-light text-black'style={{fontSize:12}}>
                            {master.map((item) => (
                  <option key={item.adminId} value={item.userName}>{item.firstName + ' (' + (item.userName) + ')'}
                  </option>

                ))}
                            </Form.Select>

                 </Col>

                 <Col className=''>  <b style={{fontSize:12}}>BROKER</b>
                            <Form.Select aria-label="Default select example" size='sm' className='bg-light text-black'style={{fontSize:12}}>
                            {broker.map((item) => (
                  <option key={item.adminId} value={item.userName}>{item.firstName + ' (' + (item.userName) + ')'}
                  </option>

                ))}
                            </Form.Select>
                 </Col>

                 <Col className=''>  <b style={{fontSize:12}}>CLIENT</b>
                            <Form.Select aria-label="Default select example" size='sm' className='bg-light text-black'style={{fontSize:12}}>
                            {Client.map((item) => (
                  <option key={item.adminId} value={item.userName}>{item.firstName + ' (' + (item.userName) + ')'}
                  </option>

                ))}
                            </Form.Select>
                 </Col>
                 
                

                  <Col className='mt-4' xl={2}>
                      <Button variant="secondary" size="sm">
                      <b  className='h6' style={{fontSize:10}}> Find Trade</b>
                      </Button>{' '}
                     
                   
                      <Button variant="secondary" size="sm">
                      <b  className='h6' style={{fontSize:10}}> Clear Search</b>
                      </Button>{' '}
                     
                      <Button variant="secondary" size="sm">
                      <b  className='h6' style={{fontSize:10}}>Export</b>
                      </Button>                    
                  </Col>
                </Row>

       <Row>       
  <Col xs={3}>
    <Card style={{ width: '10rem' }} className='mt-1'>
    <Card.Body>
      <Card.Title>CLIENT PNL</Card.Title>
        <Card.Text>
        0
      </Card.Text>
    </Card.Body>
  </Card>
  </Col>

  <Col>
    <Card style={{ width: '10rem' }} className='mt-1'>
    <Card.Body>
      <Card.Title>SELF PNL</Card.Title>
        <Card.Text>
        0
      </Card.Text>
    </Card.Body>
  </Card>
 </Col>
 </Row> 
      
    </Card.Body>
  </Card>
  

  <Card  className='mt-2'>
    
    <Card.Body>
         <DataTable className='striped bordered'>
            <thead>
              <tr>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>D</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>TRADE BY</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>O-TIME</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>NAME</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>MARKET</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>SYMBOL</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>TYPE</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>QTY</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>BET PRICE</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>BET STATUS</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>BET RESULT</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>CLOSING RATE</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>CLOSING RATE</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>MODIFY</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>CANCEL</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>STATUS</b></th>
                <th className='bg-secondary h6'><b style={{fontSize:12}}>IP</b></th>
              </tr>
            </thead>
            
          </DataTable>

      </Card.Body>
  </Card>
  </div>
  

   
  

  )
}
export default Bethistory;